import { CurrencyType } from "../enums/currency-type.enum.ts";
import { OperationStatus } from "../enums/operation-status.enum.ts";
import { OperationSystemStatus } from "../enums/operation-system-status.enum.ts";
import { WalletType } from "../enums/wallet-type.enum.ts";
import {
  PayoutType,
  TempAddressBalanceType,
} from "../types/store/payment-state.type.ts";

/** Mirrors COIN_DUST in the TON sweep service: below this the fee eats the transfer. */
const COIN_DUST = 0.01;

const SWEEPABLE_STATUS: OperationStatus[] = [
  OperationStatus.SUCCESS,
  OperationStatus.ERROR,
  OperationStatus.CANCELED,
  OperationStatus.EXPIRED,
];

export type SweepAmounts = {
  coin: TempAddressBalanceType | null;
  token: TempAddressBalanceType | null;
};

export const getSweepAmounts = (payout?: PayoutType | null): SweepAmounts => {
  const balances = payout?.address?.balances ?? [];
  const of = (type: CurrencyType): TempAddressBalanceType | null => {
    const found = balances.find((b) => b.currencyType === type);
    return found && Number(found.balance) > 0 ? found : null;
  };

  return { coin: of(CurrencyType.COIN), token: of(CurrencyType.TOKEN) };
};

export const hasSomethingToSweep = (payout?: PayoutType | null): boolean => {
  const { coin, token } = getSweepAmounts(payout);

  return !!token || Number(coin?.balance ?? 0) > COIN_DUST;
};

/** A queued or running sweep keeps the button visible so the operator sees it was taken. */
export const allowSweep = (payout?: PayoutType | null): boolean => {
  if (!payout || payout.walletType !== WalletType.TON) {
    return false;
  }

  if (
    payout.sysStatus === OperationSystemStatus.IN_SWEEP ||
    payout.sysStatus === OperationSystemStatus.WAIT_SWEEP
  ) {
    return true;
  }

  return SWEEPABLE_STATUS.includes(payout.status) && hasSomethingToSweep(payout);
};
